<template>
  <div class="init">
    <p v-if="!timerOn" style="font-size: 18px">ボタンを押したら始まります。<br>
      ブラウザを起動した状態で作業して下さい。
    </p>
    <p v-if="timerOn" style="font-size: 18px">ボタンを押したら止まります。</p>
    <p v-if="!timerOn" class="warn-msg">マジで使用するつもりなら、ポップアップを許可してください。</p>
    <h2 v-if="timerOn">次の通知まであと</h2>
    <div class="time" v-show="timerOn" style="font-size: 80px">
        {{ formatTime }}
    </div>
    <br>
    <button v-on:click="start" v-if="!timerOn" class="btn-square-shadow">開始</button>
    <button v-on:click="stop" v-if="timerOn" class="btn-square-shadow">停止</button>
  </div>
</template>

<script>
import Push from 'push.js'
export default {
  name: 'Init',
  data() {
    return {
      min: 0,
      sec: 0,
      hou: 2,
      timerOn: false,
      timerObj: null,
    }
  },
  props: {
    msg: String
  },
  methods: {
    count: function() {
      if (this.sec <= 0 && this.min >= 1) {
        this.min --;
        this.sec = 59;
      } else if(this.sec <= 1 && this.min <= 0 && this.hou <= 0) {
        this.complete();
      } else if(this.sec <= 0 && this.min <= 0 && this.hou >= 1) {
        this.hou--;
        this.min = 59;
        this.sec = 59;
      } else {
        this.sec --;
      }
    },

    firstPush: function () {
      Push.create('２時間タイマー',{
        body: "2時間経過しました。",
        timeout: 4000,
        onClick: function () {
          window.focus();
          this.close();
        }
      })
    },

    start: function() {
      let self = this;
      Push.Permission.request();
      this.timerObj = setInterval(function() {self.count()}, 1000)
      this.timerOn = true; //timerがOFFであることを状態として保持
    },

    stop: function() {
      clearInterval(this.timerObj);
      this.timerReset();
      this.timerOn = false; //timerがOFFであることを状態として保持
    },

    complete: function() {
      clearInterval(this.timerObj)
      this.firstPush();
      this.timerReset();
      this.start();
    },

    timerReset: function() {
      this.sec = 0;
      this.min = 0;
      this.hou = 2;
    }
  },
  computed: {
    formatTime: function() {
      let timeStrings = [
        this.hou.toString(),
        this.min.toString(),
        this.sec.toString()
      ].map(function(str) {
        if (str.length < 2) {
          return "0" + str
        } else {
          return str
        }
      })
      return timeStrings[0] + ":" + timeStrings[1] + ":" + timeStrings[2]
    }
  }
}
</script>

<style scoped>
.warn-msg {
  font-size: 12px;
  color: rgb(255, 0, 0);
}
.btn-square-shadow {
  display: inline-block;
  padding: 10px 30px;
  text-decoration: none;
  background: #ff6edb;/*ボタン色*/
  color: rgb(235, 233, 233);
  border-bottom: solid 4px #805374;
  border-radius: 3px;
  font-size: 18px;

}
.btn-square-shadow:active {
  /*ボタンを押したとき*/
  -webkit-transform: translateY(4px);
  transform: translateY(4px);/*下に動く*/
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2);/*影を小さく*/
  border-bottom: none;
}
</style>